import { render, staticRenderFns } from "./confirmacion_recuperar_contraseña.vue?vue&type=template&id=4acb0812&scoped=true"
import script from "./confirmacion_recuperar_contraseña.js?vue&type=script&lang=js&external"
export * from "./confirmacion_recuperar_contraseña.js?vue&type=script&lang=js&external"
import style0 from "./confirmacion_recuperar_contraseña.scss?vue&type=style&index=0&id=4acb0812&prod&scoped=true&lang=scss&external"
import style1 from "./confirmacion_recuperar_contraseña.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb0812",
  null
  
)

export default component.exports